import * as Yup from "yup"
import { transformSnakeToCamel, transformModelToJson } from "utils/transform"
import { PaginationSchema } from "model/_common"
import { BrandSchema } from "model/_base"

// Yup Schemas
export const BrandRecomSchema = Yup.object().shape({
  data: Yup.array().of(BrandSchema),
  pagination: PaginationSchema,
})
export class BrandRecomModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = BrandRecomSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      })
      return model
    } catch (error) {
      throw error
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model)
  }
}
